export default __webpack_public_path__ + "static/media/penang2017B.f19dfa1d.jpg";